import { render, staticRenderFns } from "./GroupDataEdit.vue?vue&type=template&id=48c124e6&"
import script from "./GroupDataEdit.vue?vue&type=script&lang=js&"
export * from "./GroupDataEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports